import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { LangToggle, useT } from "../../i18n/LanguageContext";
import { LOGO } from "./siteAssets";

const copy = {
  en: {
    nav: {
      home: "Home",
      whoWeAre: "Who Are We",
      survivorStory: "Survivor Story",
      ourPlan: "Our Plan",
      ourProjects: "Our Projects",
      inTheNews: "In the News",
      sherifaFilm: "SHERIFA Film",
      donate: "Donate",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      whoWeAre: "Qui sommes-nous",
      survivorStory: "Témoignage",
      ourPlan: "Notre Plan",
      ourProjects: "Nos Projets",
      inTheNews: "Dans la presse",
      sherifaFilm: "Film SHERIFA",
      donate: "Donner",
    },
  },
};

export default function SiteHeader() {
  const t = useT(copy);
  const location = useLocation();
  const navigate = useNavigate();

  const goDonate = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      document.getElementById("donate")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#donate");
      setTimeout(() => {
        document.getElementById("donate")?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  const linkClass = ({ isActive }) =>
    `transition-colors ${isActive ? "text-[#E3282B]" : "hover:text-[#8C5A3C]"}`;

  return (
    <header className="sticky top-0 z-40 bg-[#F4EDE0]/95 backdrop-blur-md border-b border-[#2A1F15]/15">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between gap-4">
        <NavLink to="/" className="flex items-center gap-3 shrink-0" data-testid="site-logo">
          <img src={LOGO} alt="Mother Hippo Foundation" className="h-10 w-auto object-contain" />
        </NavLink>
        <nav className="hidden md:flex items-center gap-5 text-sm font-semibold">
          <NavLink to="/" end className={linkClass} data-testid="nav-home">{t.nav.home}</NavLink>
          <NavLink to="/who-we-are" className={linkClass} data-testid="nav-who-we-are">{t.nav.whoWeAre}</NavLink>
          <NavLink to="/survivor-story" className={linkClass} data-testid="nav-survivor-story">{t.nav.survivorStory}</NavLink>
          <NavLink to="/our-plan" className={linkClass} data-testid="nav-our-plan">{t.nav.ourPlan}</NavLink>
          <NavLink to="/our-projects" className={linkClass} data-testid="nav-our-projects">{t.nav.ourProjects}</NavLink>
          <NavLink to="/in-the-news" className={linkClass} data-testid="nav-in-the-news">{t.nav.inTheNews}</NavLink>
          <NavLink to="/sherifa-film" className={linkClass} data-testid="nav-sherifa-film">{t.nav.sherifaFilm}</NavLink>
          <a
            href="/#donate"
            onClick={goDonate}
            data-testid="header-donate"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-[#E3282B] text-white font-bold hover:bg-[#8C5A3C] transition-colors"
          >
            {t.nav.donate} <ArrowRight size={14} />
          </a>
          <LangToggle testId="stories-lang-toggle" />
        </nav>
        <div className="md:hidden flex items-center gap-3">
          <a
            href="/#donate"
            onClick={goDonate}
            data-testid="header-donate-mobile"
            className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-[#E3282B] text-white font-bold text-sm"
          >
            {t.nav.donate}
          </a>
          <LangToggle testId="stories-lang-toggle-mobile" />
        </div>
      </div>
      <nav className="md:hidden border-t border-[#2A1F15]/10 px-6 py-2 flex items-center gap-5 text-xs font-semibold overflow-x-auto">
        <NavLink to="/" end className={linkClass} data-testid="nav-home-mobile">{t.nav.home}</NavLink>
        <NavLink to="/who-we-are" className={linkClass} data-testid="nav-who-we-are-mobile">{t.nav.whoWeAre}</NavLink>
        <NavLink to="/survivor-story" className={linkClass} data-testid="nav-survivor-story-mobile">{t.nav.survivorStory}</NavLink>
        <NavLink to="/our-plan" className={linkClass} data-testid="nav-our-plan-mobile">{t.nav.ourPlan}</NavLink>
        <NavLink to="/our-projects" className={linkClass} data-testid="nav-our-projects-mobile">{t.nav.ourProjects}</NavLink>
        <NavLink to="/in-the-news" className={linkClass} data-testid="nav-in-the-news-mobile">{t.nav.inTheNews}</NavLink>
        <NavLink to="/sherifa-film" className={linkClass} data-testid="nav-sherifa-film-mobile">{t.nav.sherifaFilm}</NavLink>
      </nav>
    </header>
  );
}
